/* =============================================================
   COSMETICA MEDICAL — comportamenti
   Regole seguite:
   - un solo gestore di scroll, limitato con requestAnimationFrame
   - ogni effetto che può nascondere un elemento ha una rete di sicurezza
   - niente dipendenze esterne
   ============================================================= */
(function () {
  'use strict';

  var doc = document.documentElement;
  var ridotto = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------
     1 · RIVELAZIONE ALLO SCROLL
     Gli elementi partono VISIBILI nel CSS. Solo se il JS gira
     davvero aggiungiamo la classe che li nasconde, e comunque
     un timeout la toglie: un contenuto invisibile è il guasto
     peggiore possibile, peggio di perdere l'animazione.
     --------------------------------------------------------- */
  var reti = [];
  function reteDiSicurezza() {
    doc.classList.remove('anima');
    document.querySelectorAll('.riv').forEach(function (el) { el.classList.add('dentro'); });
    reti.forEach(clearTimeout);
  }

  if (!ridotto && 'IntersectionObserver' in window) {
    doc.classList.add('anima');
    reti.push(setTimeout(reteDiSicurezza, 4000));

    var osservatore = new IntersectionObserver(function (voci) {
      voci.forEach(function (v) {
        if (v.isIntersecting) {
          v.target.classList.add('dentro');
          osservatore.unobserve(v.target);
        }
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 });

    document.querySelectorAll('.riv').forEach(function (el) { osservatore.observe(el); });
    window.addEventListener('error', reteDiSicurezza, { once: true });
  }

  /* ---------------------------------------------------------
     2 · HERO — sequenza d'ingresso
     Il monogramma si traccia, poi salgono le righe del titolo.
     --------------------------------------------------------- */
  var hero = document.querySelector('.hero');
  if (hero) {
    document.querySelectorAll('.traccia').forEach(function (p) {
      try {
        var l = Math.ceil(p.getTotalLength());
        p.style.setProperty('--len', l);
      } catch (e) { p.style.setProperty('--len', 400); }
    });
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { hero.classList.add('viva'); });
    });
  }

  /* ---------------------------------------------------------
     3 · I TRE INTERRUTTORI — si spengono in sequenza
     --------------------------------------------------------- */
  var blocco = document.querySelector('.interruttori');
  if (blocco && !ridotto && 'IntersectionObserver' in window) {
    var oi = new IntersectionObserver(function (voci) {
      voci.forEach(function (v) {
        if (!v.isIntersecting) return;
        var righe = blocco.querySelectorAll('.inter');
        righe.forEach(function (r, i) {
          setTimeout(function () { r.classList.add('spento'); }, 320 * i);
        });
        oi.disconnect();
      });
    }, { threshold: 0.35 });
    oi.observe(blocco);
  } else if (blocco) {
    blocco.querySelectorAll('.inter').forEach(function (r) { r.classList.add('spento'); });
  }

  /* ---------------------------------------------------------
     4 · UN SOLO GESTORE DI SCROLL
     Testata appiccicata + barra d'acquisto su mobile.
     --------------------------------------------------------- */
  var testata = document.querySelector('.testata');
  var barra = document.querySelector('.barra-mobile');
  var ancora = document.querySelector('.prod-acquisto');
  var inCorso = false;

  function alloScroll() {
    var y = window.pageYOffset || doc.scrollTop;

    if (testata) testata.classList.toggle('attaccata', y > 8);

    if (barra && ancora) {
      var r = ancora.getBoundingClientRect();
      barra.classList.toggle('su', r.bottom < 0);
    }
    inCorso = false;
  }

  window.addEventListener('scroll', function () {
    if (inCorso) return;
    inCorso = true;
    requestAnimationFrame(alloScroll);
  }, { passive: true });
  alloScroll();

  /* ---------------------------------------------------------
     5 · PAGINA PRODOTTO — scelta della variante
     Aggiorna prezzo in barra mobile e link al carrello.
     --------------------------------------------------------- */
  var varianti = document.querySelectorAll('.var input[type="radio"]');
  if (varianti.length) {
    function aggiorna() {
      var scelta = document.querySelector('.var input[type="radio"]:checked');
      if (!scelta) return;
      var p = scelta.getAttribute('data-prezzo');
      var s = scelta.getAttribute('data-listino');
      var bp = document.querySelector('.barra-mobile .p');
      if (bp) bp.innerHTML = '<b>' + p + '</b>' + (s ? ' <s>' + s + '</s>' : '');
      document.querySelectorAll('[data-carrello]').forEach(function (a) {
        var u = scelta.getAttribute('data-url');
        if (u) a.setAttribute('href', u);
      });
    }
    varianti.forEach(function (v) { v.addEventListener('change', aggiorna); });
    aggiorna();
  }

  /* ---------------------------------------------------------
     6 · GALLERIA PRODOTTO
     --------------------------------------------------------- */
  var grande = document.querySelector('.prod-figura img');
  var mini = document.querySelectorAll('.prod-mini img');
  if (grande && mini.length) {
    mini.forEach(function (m) {
      m.addEventListener('click', function () {
        grande.src = m.getAttribute('data-grande') || m.src;
        grande.alt = m.alt;
        mini.forEach(function (x) { x.classList.remove('attiva'); });
        m.classList.add('attiva');
      });
      m.setAttribute('tabindex', '0');
      m.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); m.click(); }
      });
    });
    mini[0].classList.add('attiva');
  }

  /* ---------------------------------------------------------
     7 · STORIE — il video parte al click, non da solo.
     Niente autoplay: consuma dati e infastidisce.
     --------------------------------------------------------- */
  document.querySelectorAll('.storia[data-video]').forEach(function (card) {
    var v = card.querySelector('video');
    var b = card.querySelector('.storia-play');
    if (!v || !b) return;
    b.addEventListener('click', function () {
      // metto in pausa eventuali altri video prima di partire
      document.querySelectorAll('.storia video').forEach(function (altro) {
        if (altro !== v) { altro.pause(); altro.closest('.storia').classList.remove('attiva'); }
      });
      card.classList.add('attiva');
      v.controls = true;
      var p = v.play();
      if (p && p.catch) { p.catch(function () { card.classList.remove('attiva'); v.controls = false; }); }
    });
    v.addEventListener('ended', function () {
      card.classList.remove('attiva');
      v.controls = false;
      v.currentTime = 0;
    });
  });

  /* ---------------------------------------------------------
     8 · PRIMA / DOPO — ordine diverso a ogni visita
     Le coppie stanno gia' nel DOM, sparse in piu' punti della
     pagina: senza JavaScript si vedono comunque, nell'ordine
     scritto. Qui le raccogliamo tutte, mescoliamo e le
     rimettiamo negli stessi contenitori, tanti per contenitore
     quanti ne aveva prima. Nessuna coppia sparisce, nessuna si
     duplica: cambia solo l'ordine.
     --------------------------------------------------------- */
  var griglie = document.querySelectorAll('.pd-griglia');
  if (griglie.length) {
    var coppie = [];
    var capienze = [];
    Array.prototype.forEach.call(griglie, function (g) {
      var figlie = Array.prototype.slice.call(g.children);
      capienze.push(figlie.length);
      coppie = coppie.concat(figlie);
    });

    // mescolata di Fisher-Yates
    for (var i = coppie.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = coppie[i]; coppie[i] = coppie[j]; coppie[j] = t;
    }

    // ricollocazione: si sposta solo se il conto torna
    var totale = capienze.reduce(function (a, b) { return a + b; }, 0);
    if (totale === coppie.length) {
      var k = 0;
      Array.prototype.forEach.call(griglie, function (g, n) {
        var pezzo = coppie.slice(k, k + capienze[n]);
        k += capienze[n];
        pezzo.forEach(function (el) { g.appendChild(el); });
      });
    }
  }

  /* ---------------------------------------------------------
     9 · TITOLI SU UNA RIGA — rete di sicurezza
     Il CSS riduce il corpo del titolo quanto basta a farlo stare
     su una riga. Se il calcolo sbaglia di poco, meglio andare a
     capo che essere tagliati: qui lo misuriamo davvero.
     --------------------------------------------------------- */
  var titoli = document.querySelectorAll('.h1riga');
  function controllaTitoli() {
    titoli.forEach(function (t) {
      t.classList.remove('va-a-capo');
      // l'hero ha le righe dentro contenitori che tagliano: vanno misurate loro
      var pezzi = t.querySelectorAll('.riga i');
      var lista = pezzi.length ? pezzi : [t];
      var stretto = false;
      Array.prototype.forEach.call(lista, function (el) {
        if (el.scrollWidth > el.parentElement.clientWidth + 1) stretto = true;
      });
      if (!pezzi.length && t.scrollWidth > t.clientWidth + 1) stretto = true;
      if (stretto) t.classList.add('va-a-capo');
    });
  }
  if (titoli.length) {
    controllaTitoli();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(controllaTitoli);
    var attesa;
    window.addEventListener('resize', function () {
      clearTimeout(attesa);
      attesa = setTimeout(controllaTitoli, 150);
    });
  }

  /* ---------------------------------------------------------
    10 · MENU A SCOMPARSA
     Il menu è un <details>: apre e chiude da solo anche senza
     JavaScript. Qui aggiungiamo solo le comodità — si chiude
     cliccando fuori, premendo Esc o scegliendo una voce.
     --------------------------------------------------------- */
  var menu = document.querySelector('.menu');
  if (menu) {
    document.addEventListener('click', function (e) {
      if (menu.open && !menu.contains(e.target)) menu.open = false;
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.open) { menu.open = false; menu.querySelector('summary').focus(); }
    });
    menu.querySelectorAll('.menu-pannello a').forEach(function (a) {
      a.addEventListener('click', function () { menu.open = false; });
    });
  }

  /* ---------------------------------------------------------
    11 · ANNO NEL PIEDE
     --------------------------------------------------------- */
  var anno = document.querySelector('[data-anno]');
  if (anno) anno.textContent = new Date().getFullYear();
})();

/* --- selettore quantita ---------------------------------------------------
   Aggiunto il 19/08/2026 con l'interfaccia da negozio. */
document.addEventListener('click', function (e) {
  var b = e.target.closest('[data-qta]');
  if (!b) return;
  var campo = b.parentElement.querySelector('input[name="quantity"]');
  if (!campo) return;
  var v = parseInt(campo.value, 10) || 1;
  campo.value = Math.max(1, b.dataset.qta === '+' ? v + 1 : v - 1);
  campo.dispatchEvent(new Event('change', { bubbles: true }));
});

/* =========================================================================
   IL CASSETTO DEL CARRELLO NON STA PIU' QUI
   =========================================================================
   Qui c'era una copia piu' vecchia del cassetto, doppia di assets/cassetto.js:
   tutti e due registravano un ascoltatore sul submit del form /cart/add e tutti
   e due mandavano il POST. Un clic su "Aggiungi al carrello" metteva DUE pezzi
   nel carrello.
   Non si vedeva perche' questo file aveva un errore di sintassi e non partiva
   affatto; riparandolo sarebbe saltato fuori il doppio.
   Tenuta la versione buona, assets/cassetto.js: quella aggiorna anche il
   contatore in testata e gestisce il pulsante col <span> dentro.
   20/08/2026
   ========================================================================= */
